import { Breakpoints, styled } from '@vw-marketing/us-components';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledManageContacts = styled.div`
    display: flex;
    flex-direction: column;
    
    ${({ theme }: { theme: VWTheme }) => {
    return `
      margin-top: ${theme.size.static350};
      gap: ${theme.size.static350};

      @media (min-width: ${Breakpoints.b560}px) {
        margin-top: ${theme.size.static400};
        gap: ${theme.size.static400};
      }
    `;
  }}
`;

export const StyledDescription = styled.div`
  color: ${( props ) =>  props.theme.colors.content.tertiary };
`;

export const StyledAlerts = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${( props ) =>  props.theme.size.static400 };
`;
